import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function ProtectedRoute({ children, requireAdmin = false, requireVendor = false, requireCompanyAdmin = false }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === undefined) {
    return (
      <div className="min-h-screen flex items-center justify-center text-[var(--lc-gray)]" data-testid="auth-loading">
        Chargement…
      </div>
    );
  }
  if (user === null) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  if (requireAdmin && user.role !== "admin") {
    return <Navigate to="/" replace />;
  }
  if (requireVendor) {
    if (user.role === "admin") return <Navigate to="/admin" replace />;
    if (!user.vendor) return <Navigate to="/select-profile" replace />;
  }
  if (requireCompanyAdmin) {
    if (user.role === "admin") return <Navigate to="/admin" replace />;
    if (user.vendor) return <Navigate to="/client" replace />;
    if (!user.admin_space) return <Navigate to="/select-profile" replace />;
  }
  return children;
}
